// Create ProjectUtil
const ProjectUtil = {};

// These values are set in router's ready function
ProjectUtil.preloadedJSON = null;
ProjectUtil.pubSub = null;
ProjectUtil.audioManager = null;
ProjectUtil.cartManager = null;
ProjectUtil.vimeoLoadRequested = false;
ProjectUtil.vimeoReady = false;
ProjectUtil.initialPage = true;
ProjectUtil.pageData = {};

/**
 * Check userAgent for iOS string, for special handling
 */
ProjectUtil.isIOS = function () {
	return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Get a node in JSON by ID
 */
ProjectUtil.getJSONNode = function (json, id) {
	return ProjectUtil.getObjByProp(json, 'id', id);
};

/**
 * Find an object in an array by checking for a property and a matching value.
 */
ProjectUtil.getObjByProp = function (ar, prop, val) {
	if (ar) {
		const tVal = val.toString();
		const tLength = ar.length;
		for (let i = 0; i < tLength; i++) {
			if (ar[i][prop]) {
				if (ar[i][prop].toString() === tVal) {
					return ar[i];
				}
			}
		}
	}
	// No matching object was found, return an empty object.
	console.warn(`[ProjectUtil] getObjByProp: no object with property ${prop} = ${val} found!`);
	return {};
};

/**
 * Search an array of objects to find the index of first object with property matching the given value
 */
ProjectUtil.getObjIndexByProp = function (ar, prop, val) {
	if (ar) {
		const tVal = val.toString();
		const tLength = ar.length;
		for (let i = 0; i < tLength; i++) {
			if (ar[i].hasOwnProperty(prop)) {
				if (ar[i][prop].toString() === tVal) {
					return i;
				}
			}
		}
	}
	// No matching object was found, return -1 (to indicate not found).
	console.warn(`[ProjectUtil] getObjIndexByProp: no object with property ${prop} = ${val} found!`);
	return -1;
};

/**
 * Request the audioManager mute audio
 */
ProjectUtil.requestMute = function () {
	if (ProjectUtil.audioManager) {
		ProjectUtil.audioManager.mute();
	}
};

/**
 * Request the audioManager unmute audio
 */
ProjectUtil.requestUnmute = function () {
	if (ProjectUtil.audioManager) {
		ProjectUtil.audioManager.unmute();
	}
};

/**
 * Pass a callback function to be fired on the next animation frame
 */
ProjectUtil.onNextFrame = function (func, scope) {
	if (window.requestAnimationFrame) {
		window.requestAnimationFrame(() => {
			func.apply(scope);
		});
	} else {
		setTimeout(() => {
			func.apply(scope);
		}, 1000 / 30); // 30fps
	}
};

/**
 * Replace a blank space with '&nbsp' to prevent hanging words. Only applies to sentences of more than 3 words.
 */
ProjectUtil.hangingWord = function (content) {
	const contentArray = content.split(" ");
	if (contentArray.length > 3) {
		return content.substring(0, content.lastIndexOf(" ")) + '&nbsp;' + content.substring(content.lastIndexOf(" ") + 1, content.length);
	} else {
		return content;
	}
};

/**
 * Make an API request.
 * query - required - String: the API call being requested
 * data - optional - Object: data to be passed in API request
 * cbFunc - required - Function: callback to handle the API response (success or error)
 * cbFail - optional - Function: callback to handle API failure
 */
ProjectUtil.requestAPI = function (query, data = {}, cbFunc = null, cbFail = null) {
	/*
	fetch(`api/?${query}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	})
	*/
	//const queryParams = new URLSearchParams(data).toString(); // probably better?  But URL endcoding is breaking search
	const queryParams = Object.keys(data).map(key => `${key}=${data[key]}`).join('&');
	const url = `api/?${query}&${queryParams}`;
	fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	})
		.then(response => response.json())
		.then(response => {
			// Validate response
			if (response && typeof response === 'object') { // Add additional validation appropriate to your 
				// Trigger message for any global API listeners [ex. badge notification module]
				ProjectUtil.pubSub.trigger('handleApiResponse', response);
				// Return success message
				if (typeof cbFunc === 'function') {
					cbFunc(response);
				} else {
					console.error('[ProjectUtil].requestAPI: cbFunc is not a function:', cbFunc);
				}
			} else {
				// Return error message.
				console.error("[ProjectUtil].requestAPI: failed to fetch data", response);
				if (cbFail && typeof cbFail === "function") {
					cbFail({});
				}
			}
		})
		.catch(error => {
			console.error('ProjectUtil.requestAPI fail', error, data);
			if (cbFail && typeof cbFail === "function") {
				cbFail({});
			}
		});
};

// Advanced sorting array
/* jshint ignore:start */
ProjectUtil.firstBy = (function () {
	function e(f) {
		f.thenBy = t;
		return f;
	}
	function t(y, x) {
		x = this;
		return e(function (a, b) {
			return x(a, b) || y(a, b);
		});
	}
	return e;
})();
/* jshint ignore:end */

ProjectUtil.vimeoInit = function () {
	if (ProjectUtil.vimeoLoadRequested) {
		return;
	}
	// Create a script element and insert it into the DOM
	var script = document.createElement('script');
	script.src = 'https://player.vimeo.com/api/player.js';
	script.onload = function () {
		ProjectUtil.vimeoReady = true;
	};
	document.head.appendChild(script);
	this.vimeoLoadRequested = true;
};

/**
 * These are functions carried over from utils.js - they used to be attached to the window object.
 */
/*
// Function to shuffle an array
ProjectUtil.shuffleArray = function(array) {
	if (array === undefined || array === null) {
		throw new TypeError('"array" is null or not defined');
	}

	let currentIndex = array.length,
		temporaryValue,
		randomIndex;

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}

	return array;
}
*/
/*
// Function to create a deep copy of an object
export function deepCopyObject(obj) {
	if (obj === undefined || obj === null) {
		throw new TypeError('obj is null or not defined');
	}

	return JSON.parse(JSON.stringify(obj));
}
*/

//get device dimensions - including scrollbar on desktop
ProjectUtil.getViewport = function () {
	let e = window,
		a = 'inner';
	if (!('innerWidth' in window)) {
		a = 'client';
		e = document.documentElement || document.body;
	}
	return { width: e[a + 'Width'], height: e[a + 'Height'] };
};


// check if the 'viewport' is greater-than/equal-to
ProjectUtil.viewportGTE = function (min) {
	if (window.matchMedia) {
		return window.matchMedia('(min-width: ' + min + 'px)').matches;
	}
	return ProjectUtil.getViewport().width >= min;
};

/**
 * Get the value of a querystring parameter
 * @param {*} querystring 
 * @returns the matched value of the querystring, or an empty string if not found
 */
ProjectUtil.getQueryString = function (querystring) {
	let query = window.location.search.substring(1),
		vars = query.split("&"),
		pair,
		totalVars = vars.length,
		i;

	for (i = 0; i < totalVars; i++) {
		pair = vars[i].split("=");
		if (pair[0] === querystring) {
			return pair[1];
		}
	}
	return ('');
};

ProjectUtil.htmlspecialchars = function (tText) {
	let map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;'
	};

	return tText.replace(/[&<>"']/g, function (m) { return map[m]; });
};

module.exports = ProjectUtil;